module.exports = __webpack_public_path__ + "img/weal_6.585c1198.jpg";